import { render, staticRenderFns } from "./WorkDetailModule.vue?vue&type=template&id=7e1f3406&scoped=true&"
import script from "./WorkDetailModule.vue?vue&type=script&lang=js&"
export * from "./WorkDetailModule.vue?vue&type=script&lang=js&"
import style0 from "./WorkDetailModule.vue?vue&type=style&index=0&id=7e1f3406&scoped=true&lang=scss&"
import style1 from "./WorkDetailModule.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e1f3406",
  null
  
)

export default component.exports